/**
 * SceneObjectCache.js
 * Three.js scene object'lerini ID ile cache'leyen global singleton
 * Traverse yerine O(1) lookup için kullanılır
 */

class SceneObjectCache {
  constructor() {
    this.sockets = new Map(); // socketId -> THREE.Group
    this.machines = new Map(); // machineId -> THREE.Group
    this.panels = new Map(); // panelId -> THREE.Group
    this.boxes = new Map(); // boxId -> THREE.Group
    this.lightSwitches = new Map(); // lightSwitchId -> THREE.Group
    this.fixtures = new Map(); // fixtureId -> THREE.Group
    this.wires = new Map(); // wireId -> THREE.Line
    this.feeders = new Map(); // feederId -> THREE.Line
  }

  // Socket cache
  addSocket(id, object) {
    this.sockets.set(id, object);
  }

  getSocket(id) {
    return this.sockets.get(id);
  }

  removeSocket(id) {
    this.sockets.delete(id);
  }

  // Machine cache
  addMachine(id, object) {
    this.machines.set(id, object);
  }

  getMachine(id) {
    return this.machines.get(id);
  }

  removeMachine(id) {
    this.machines.delete(id);
  }

  // Panel cache
  addPanel(id, object) {
    this.panels.set(id, object);
  }

  getPanel(id) {
    return this.panels.get(id);
  }

  removePanel(id) {
    this.panels.delete(id);
  }

  // Box cache
  addBox(id, object) {
    this.boxes.set(id, object);
  }

  getBox(id) {
    return this.boxes.get(id);
  }

  removeBox(id) {
    this.boxes.delete(id);
  }

  // Light Switch cache
  addLightSwitch(id, object) {
    this.lightSwitches.set(id, object);
  }

  getLightSwitch(id) {
    return this.lightSwitches.get(id);
  }

  removeLightSwitch(id) {
    this.lightSwitches.delete(id);
  }

  // Fixture cache
  addFixture(id, object) {
    this.fixtures.set(id, object);
  }

  getFixture(id) {
    return this.fixtures.get(id);
  }

  removeFixture(id) {
    this.fixtures.delete(id);
  }

  // Wire/Feeder cache
  addWire(id, object) {
    this.wires.set(id, object);
  }

  getWire(id) {
    return this.wires.get(id);
  }

  removeWire(id) {
    this.wires.delete(id);
  }

  addFeeder(id, object) {
    this.feeders.set(id, object);
  }

  getFeeder(id) {
    return this.feeders.get(id);
  }

  removeFeeder(id) {
    this.feeders.delete(id);
  }

  // Utility methods
  clear() {
    this.sockets.clear();
    this.machines.clear();
    this.panels.clear();
    this.boxes.clear();
    this.lightSwitches.clear();
    this.fixtures.clear();
    this.wires.clear();
    this.feeders.clear();
  }

  getStats() {
    return {
      sockets: this.sockets.size,
      machines: this.machines.size,
      panels: this.panels.size,
      boxes: this.boxes.size,
      lightSwitches: this.lightSwitches.size,
      fixtures: this.fixtures.size,
      wires: this.wires.size,
      feeders: this.feeders.size,
      total: this.sockets.size + this.machines.size + this.panels.size +
             this.boxes.size + this.lightSwitches.size + this.fixtures.size +
             this.wires.size + this.feeders.size
    };
  }
}

// Global singleton instance
const sceneObjectCache = new SceneObjectCache();

export default sceneObjectCache;
